export default __webpack_public_path__ + "static/media/ted4.2f4e9ff4.jpg";